exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".comments-row{transition:opacity .3s ease-out}.comments-row.ng-leave,.comments-row.ng-leave-active{opacity:0}.comments-row.updating .comment-content,.comments-row.updating .comment-functions,.comments-row.updating .user-comment-meta{opacity:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader!./ilmn-ui-comments/scripts/commentsModal.styles.less
// module id = 27
// module chunks = 0